<template>
  <div class="tabBox">
    <div class="tabHead">
      <div :class="['tab',(active === 0 ? 'tabActive' : '')]" @click="active=0">
        <i class="el-icon-school" />{{$t('index.jd')}}
      </div>
      <div :class="['tab',(active === 1 ? 'tabActive' : '')]" @click="active=1">
        <i class="el-icon-s-ticket" />{{$t('index.ddwl')}}
      </div>
      <div :class="['tab',(active === 2 ? 'tabActive' : '')]" @click="active=2">
        <i class="el-icon-guide" />{{$t('index.xl')}}
      </div>
    </div>
    <div class="tabBody">
      <div class="item" v-if="active === 0">
         <search-box-hotel :pick-option="pickOption" />
      </div>
      <div class="item" v-else-if="active === 1">
        <search-box-ticket :pick-option="pickOption" />
      </div>
      <div class="item" v-else-if="active === 2">
        <search-box-tour :pick-option="pickOption" />
      </div>
    </div>
  </div>
</template>

<script>
import SearchBoxHotel from './components/hotel'
import SearchBoxTicket from './components/ticket'
import SearchBoxTour from './components/tour'
export default {
  name: 'SearchBox',
  components: {SearchBoxTour, SearchBoxTicket, SearchBoxHotel},
  data () {
    return {
      active: 0,
      pickOption: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },
  created () {

  },
  methods: {
  }
}
</script>
<style>
.listForm{
  display: flex;
  flex-direction: column;
  width: 100%;
}
.listForm .li{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
  margin-top: 12px;
  align-items: center;
}
.ipt .el-input__inner{
  color: #222;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  line-height: 24px;
}
</style>
<style scoped lang="scss">
.tabBox{
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  padding:0;
  text-align: left;
  border-radius: 10px;
  box-shadow: 0 1px 10px 0 rgba(0,0,0,.3);
  overflow: hidden;

  & .tabBody {
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    padding:24px;
    background-color: #fff;
  }
  & .tabHead{
    color: #ffffff;
    font-size: 16px;
    background-color: rgba(3,28,59,0.6);
    border-radius: 0px 2px 0px 0px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    width: 100%;

    & .tab{
      display: inline-block;
      min-width: 80px;
      text-align: center;
      padding: 8px 15px;
      cursor: pointer;
      & i {
        margin-right: 5px;
      }
    }
    & .tabActive{
      background-color: #fff;
      color: #000000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/searchBox/searchBox.vue